import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Card from '@components/Card';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';

const Container = styled(Card)`
  padding: ${({ theme }) => theme.spacing(8)};
  margin: 0;
  flex-direction: column;
`;

const Message = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: ${({ theme }) => theme.spacing(0, 0, 6, 0)};
`;

const Button = styled(SimpleButton)`
  width: 107px;
`;

function SectionNote({ message, actionText, action }) {
  return (
    <Container>
      <Message>{message}</Message>
      <Button
        label={actionText}
        color={COLOR.SECONDARY}
        size={SIZE.MEDIUM}
        onClick={action}
      />
    </Container>
  );
}

SectionNote.propTypes = {
  message: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default SectionNote;
